import React from 'react';
import clsx from 'clsx';
import { CardHeader } from './CardHeader/CardHeader';
import { CardProps, CardPropsComposition } from './tools/Card.model';

import useStyles from './Card.style';

export const Card: React.FC<CardProps> & CardPropsComposition = ({
    size = 'small',
    borderDirection = 'left',
    borderColor = '',
    type='base',
    layout='normal',
    overflow = 'hidden',
    fullWidth,
    children,
    className,
    testId = 'card',
    autoTestId,
    hoverable = false,
    id,
  }) => {
  const c = useStyles({size, borderDirection, borderColor, type, fullWidth, overflow, layout});

  return (
    <div
      className={clsx(c.card, className, hoverable && c.hoverable)}
      data-testid={testId}
      id={id}
      data-autotestid={autoTestId}
    >
      {children}
    </div>
  );
};

Card.Header = CardHeader;
